import { stringify } from 'qs';
import isIphone from '../isIphone';
import getAppName from '../getAppName';
import getDeviceInfo from '../getDeviceInfo';
import getDeviceInfoSync from '../getDeviceInfoSync';
import { envMap } from '../getEnv/base';
import { Platform } from 'react-native';
const appInfoMap = {
    kwaiying: {
        name: 'kwaiying',
        schema: 'kwaiying://mv',
        pkgName: 'com.kwai.videoeditor',
        pkgId: '1195860596',
        pc: 'https://www.kuaishou.com/kuaiying',
        getULink: (schema) => {
            return ('https://ky.kuaishou.com/schema?' + encodeURIComponent(schema));
        },
        getWebLink: (http, { showTopBar = false, type = 1, title = '', bgColor = '#141414', newBgColor, } = {}) => {
            const opt = {
                showTopBar,
                type,
                title,
                bgColor,
            };
            if (Platform.OS === 'android' && newBgColor) {
                opt.newBgColor = newBgColor;
            }
            const deviceInfo = getDeviceInfoSync();
            let url = http;
            if (deviceInfo.isOverseas) {
                url = url.replace('https://ky.kuaishou.com', 'https://m.kittyfunny.com');
                url = url.replace('https://h5.kwaiying.com', 'https://m.kittyfunny.com');
                url = url.replace('https://share.kwaiying.com', 'https://share.kittyfunny.com');
            }
            return `kwaiying://web?url=${encodeURIComponent(url)}&${stringify(opt)}`;
        },
        setNewAppLink: async (axiosInstance, clipboard, opt) => {
            if (opt.egid) {
                // 服务端不支持 先不默认上播啊
                // axiosInstance
                //     .post('/rest/n/kmovie/grow/common/report', {
                //         egid: opt.egid, //加密gid
                //         from: opt.from, // 上报来源
                //         type: opt.type || 3,
                //         content: opt.content || opt.schema,
                //     })
                //     .then(() => {
                //         console.log('setNewAppLink succes');
                //     })
                //     .catch((e: any) => {
                //         console.log('setNewAppLink error', e);
                //     });
            }
            else {
                // 目前两边的文字是固定的，所以直接写死
                // 复制文案要等结束后再跳转，否则复制会失败
                return clipboard.setString(`【快影VIP】助力免费获得快影VIP ${opt.schema}，快来帮忙好友助力，立即免费获得快影VIP`);
            }
        },
        getApkUrl: async function (axiosInstance) {
            let res = 'https://js.a.kspkg.com/kos/nlav10814/kuaiying-official--5.58.0.558002_82eae7.apk';
            try {
                res =
                    (await axiosInstance.get('/rest/n/kmovie/app/download/getUrl')).downloadUrl || res;
            }
            catch (e) { }
            return res;
        },
        setGuiYin: async function (axiosInstance, opt) {
            const deviceInfo = await getDeviceInfo();
            if (!opt?.activity || !deviceInfo?.globalId) {
                console.error('setGuiYin error, need activity and globalId');
                return;
            }
            // @ts-ignore
            const mi = deviceInfo.idfa || deviceInfo.imei || '';
            const globalId = deviceInfo.globalId;
            const os = isIphone() ? 'iOS' : 'ANDROID';
            const params = `?app=KUAISHOU_VIDEO_EDITOR&cid=ksht&mi=${mi}&globalId=${globalId}&fr=${os}&activity=${opt.activity}&page=${opt.from || getAppName()}`;
            const newUrl = `${envMap.production.url}/api/v1/activity/record${params}`;
            const oldUrl = `https://api.getkwai.com/log-server/api/v1/activity/record${params}`;
            // 旧地址不支持Post请求，只能用get。数据同学说要上报两份
            axiosInstance
                .get(oldUrl, {
                disableSign: true,
            })
                .catch((e) => {
                console.log('setGuiYin old error', e);
            });
            // 普通请求ios会在跳转时被cancel
            if (window.navigator?.sendBeacon) {
                return window.navigator.sendBeacon(newUrl);
            }
            return axiosInstance
                .get(newUrl, {
                disableSign: true,
            })
                .catch((e) => {
                console.log('setGuiYin error', e);
            });
        },
    },
    m2u: {
        name: '一甜',
        schema: 'm2u://',
        pkgName: 'com.kwai.m2u',
        pkgId: '1415653267',
        pc: 'https://1tian.kuaishou.com',
        getULink: (schema) => {
            return schema.replace('m2u://', 'https://1tian.kuaishou.com/app/');
        },
    },
    kwai: {
        name: 'all_kwai',
        schema: 'kwai://home/hot',
        pkgName: 'com.smile.gifmaker',
        pkgId: '440948110',
        pc: 'https://www.kuaishou.com',
        getULink: (schema) => {
            return schema.replace('kwai://', 'https://m.ssl.kuaishou.com/app/');
        },
        getWebLink: (http, opt) => {
            opt;
            // android 不支持schema直接跳转
            if (isIphone()) {
                return `kwai://webview?url=${encodeURIComponent(http)}`;
            }
            return http;
        },
    },
    ksnebula: {
        name: 'apps.ksnebula',
        schema: 'ksnebula://home/hot',
        pkgName: 'com.kuaishou.nebula',
        pkgId: '1472502819',
        pc: 'https://www.kuaishou.com',
        getULink: (schema) => {
            return schema.replace('ksnebula://', 'https://m.ssl.kuaishou.com/app/');
        },
        getWebLink: (http, opt) => {
            opt;
            return `ksnebula://webview?url=${encodeURIComponent(http)}`;
        },
    },
    wechat: {
        name: 'all_wechat',
        schema: 'weixin://',
        pkgName: 'com.tencent.mm',
        pkgId: '836500024',
        pc: 'https://www.wechat.com/',
        getULink: (schema) => {
            return schema;
            // 不知道地址是啥，暂时也用不上
            // return schema.replace(
            //     'weixin://',
            //     'https://m.ssl.kuaishou.com/app/',
            // );
        },
    },
    qq: {
        name: 'share_qq',
        prefix: 'mqq',
        schema: 'mqq://',
        pkgName: 'com.tencent.mobileqq',
    },
    weibo: {
        name: 'str_share_to_weibo',
        prefix: 'sinaweibo',
        schema: 'sinaweibo://gotohome',
        pkgName: 'com.sina.weibo',
    },
};
export default appInfoMap;
